<app-megamenu></app-megamenu>

<div class="page-content">
  <div class="hero-section">
    <div class="container">
      <h1>Our Pest Control Services</h1>
      <p>Professional, effective, and environmentally responsible pest management solutions for your home and business.</p>
    </div>
  </div>

  <div class="services-section">
    <div class="container">
      <div class="services-grid">
        <mat-card *ngFor="let service of services" class="service-card">
          <mat-card-header>
            <div mat-card-avatar>
              <mat-icon class="service-icon">{{ service.icon }}</mat-icon>
            </div>
            <mat-card-title>{{ service.title }}</mat-card-title>
          </mat-card-header>
          
          <mat-card-content>
            <p>{{ service.description }}</p>
            
            <ul class="feature-list">
              <li *ngFor="let feature of service.features">
                <mat-icon>check_circle</mat-icon>
                {{ feature }}
              </li>
            </ul>
          </mat-card-content>
          
          <mat-card-actions>
            <button mat-raised-button class="learn-more-btn">
              Learn More
            </button>
            <button mat-button class="quote-btn">
              Get Quote
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="cta-section">
    <div class="container">
      <h2>Ready to Get Started?</h2>
      <p>Contact us today for a free consultation and customized pest control solution.</p>
      <button mat-raised-button class="cta-button" (click)="callPhone()">
        <mat-icon>phone</mat-icon>
        Call {{ config.phone.display }}
      </button>
    </div>
  </div>
</div>

<!-- Service Offerings Section -->
<app-service-offerings></app-service-offerings>

<app-footer></app-footer>